// extracted by mini-css-extract-plugin
export var featuresTable = "FeaturesTable-module--featuresTable--ddf29";